import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

// GeofencePreviewController — read-only Leaflet map showing a single geofence.
// Used on the geofence show page.
// Value: fence — JSON from Geofence#to_leaflet_layer_json
export default class extends Controller {
  static values = { fence: Object }

  connect() {
    this.map = L.map(this.element, { zoomControl: true, scrollWheelZoom: false })

    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
      attribution: "© <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors © <a href='https://carto.com/'>CARTO</a>",
      maxZoom: 19,
    }).addTo(this.map)

    const fence = this.fenceValue
    if (!fence || !fence.kind) {
      this.map.setView([51.505, -0.09], 13)
      return
    }

    const style = {
      color:       fence.color || "#ef4444",
      fillColor:   fence.color || "#ef4444",
      fillOpacity: 0.18,
      weight:      2,
    }

    let layer = null
    if (fence.kind === "circle" && fence.center_lat != null && fence.center_lng != null) {
      layer = L.circle([fence.center_lat, fence.center_lng], { radius: fence.radius_m || 250, ...style })
    } else if (fence.kind === "polygon") {
      const coords = fence.polygon_geojson?.coordinates || fence.coordinates
      if (coords && coords[0]) {
        const latlngs = coords[0].map(([lng, lat]) => [lat, lng])
        layer = L.polygon(latlngs, style)
      }
    }

    if (layer) {
      layer.addTo(this.map)
      try {
        this.map.fitBounds(layer.getBounds().pad(0.3))
      } catch (_) {
        this.map.setView([51.505, -0.09], 13)
      }
    } else {
      this.map.setView([51.505, -0.09], 13)
    }

    setTimeout(() => {
      if (this.map) {
        this.map.invalidateSize()
        if (layer) {
          try {
            this.map.fitBounds(layer.getBounds().pad(0.3))
          } catch (_) {}
        }
      }
    }, 150)
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }
}
